import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appZoomScale]',
  standalone: false,
})
export class ZoomScaleDirective implements OnInit {
  private readonly minZoom = 1;
  private readonly maxZoom = 1.5;
  private readonly minScale = 0.75;
  private readonly maxScale = 1;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit() {
    this.updateScale();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateScale();
  }

  private updateScale(): void {
    const zoom = window.devicePixelRatio || 1;
    let scale = this.maxScale;

    if (zoom <= this.minZoom) {
      scale = this.maxScale;
    } else if (zoom >= this.maxZoom) {
      scale = this.minScale;
    } else {
      const factor = (zoom - this.minZoom) / (this.maxZoom - this.minZoom);
      scale = this.maxScale - factor * (this.maxScale - this.minScale);
    }

    this.renderer.setStyle(this.el.nativeElement, 'transform', `scale(${scale},${scale})`);
  }
}
